import React, { ReactNode } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "src/Shared/Hooks";
import { Navigate } from "react-router-dom";

interface PermissionProps {
  permission: string;
  children: React.ReactNode;
  redirect?: boolean;
}
const Permission: React.FC<PermissionProps> = observer(
  ({ permission, children, redirect }) => {
    const {
      rootStore: {
        authStore: { isGranted },
      },
    } = useStore();

    const allowed = isGranted(permission);

    if (!allowed) {
      if (redirect) {
        return <Navigate to="/" replace />;
      }
      return null;
    }

    return <>{children}</>;
  },
);

export default Permission;
